
    import * as React from 'react';

    const CheckboxUnchecked12 = ({ color = 'currentcolor', height = '12px', width = '12px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 12 12" style={svgStyle}><path d="M1.125 10.875h9.75v-9.75h-9.75v9.75zm.75-.75v-8.25h8.25v8.25h-8.25z" /></svg>
        </div>
      );
    };

    CheckboxUnchecked12.displayName = 'CheckboxUnchecked12';

    export default CheckboxUnchecked12;
  